export default window.API.wrap;
